export default function HeaderHome({
    heading,
    color,
    as: HeadingTag = "h2",
}){

    return(
        <div className="mb-0">
            <HeadingTag
                className="mt-6 text-center text-2xl font-extrabold text-gray-900"
                style={color ? { color } : undefined}
            >
                {heading}
            </HeadingTag>

        </div>


    )
}
